(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brevo-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const form = document.getElementById('sib-form-newsletter');
      if (!form) return;

      const container = form.closest('#sib-form-container');
      const errorEl = container.querySelector('#error-message');
      const successEl = container.querySelector('#success-message');
      const btn = form.querySelector('[type="submit"]');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.style.display = 'none';
        successEl.style.display = 'none';
        btn.disabled = true;

        try {
          await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            mode: 'no-cors',
          });
          successEl.style.display = 'block';
          form.reset();
        } catch {
          errorEl.style.display = 'block';
        } finally {
          btn.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(sectionId) {
      var track = document.getElementById('track-' + sectionId);
      var dotsContainer = document.getElementById('dots-' + sectionId);
      if (!track || !dotsContainer) return;

      var slides = Array.from(track.children);
      if (slides.length === 0) return;

      var current = 0;
      var dots = [];

      function isMobile() {
        return window.innerWidth < 768;
      }

      function buildDots() {
        dotsContainer.innerHTML = '';
        dots = [];
        slides.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.className = 'dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          btn.addEventListener('click', function () { goTo(i); });
          dotsContainer.appendChild(btn);
          dots.push(btn);
        });
      }

      function updateDots() {
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      function goTo(index) {
        current = Math.max(0, Math.min(index, slides.length - 1));
        if (!isMobile()) return;
        var slideWidth = track.parentElement.offsetWidth;
        track.style.transform = 'translateX(-' + (current * slideWidth) + 'px)';
        updateDots();
      }

      var startX = 0;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (!isMobile()) return;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          goTo(diff > 0 ? current + 1 : current - 1);
        }
      }, { passive: true });

      var wasDesktop = !isMobile();
      window.addEventListener('resize', function () {
        var isDesktop = !isMobile();
        if (isDesktop !== wasDesktop) {
          wasDesktop = isDesktop;
          if (isDesktop) {
            track.style.transform = '';
          } else {
            goTo(current);
          }
        }
      });

      buildDots();
      if (isMobile()) goTo(0);
    }

    function initAll() {
      document.querySelectorAll('[data-carousel-id]').forEach(function (wrapper) {
        initCarousel(wrapper.dataset.carouselId);
      });
    }

    initAll();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function () {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-2"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-3"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a1"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a10"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a2"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a3"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a4"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a5"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a6"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a7"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a8"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-recs-a9"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-search-recommendations"]) return;
  try {
    
$(document).ready(function(){
  $('.prod-rec-slider-container').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
      }
    ]        
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-branch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('branch-map')) {
    class BranchMap extends HTMLElement {
      #mapEl = null;
      #fallback = null;

      connectedCallback() {
        this.#mapEl = this.querySelector('[data-map-el]');
        this.#fallback = this.querySelector('[data-map-fallback]');

        const placeId = this.dataset.placeId;
        if (!placeId || !this.#mapEl) {
          this.#showFallback();
          return;
        }

        this.#loadGoogleMaps()
          .then(() => this.#fetchPlace(placeId))
          .catch(() => this.#showFallback());
      }

      #loadGoogleMaps() {
        if (window.google?.maps?.places) return Promise.resolve();

        return new Promise((resolve, reject) => {
          const existing = document.querySelector('script[data-google-maps]');
          if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', reject);
            return;
          }
          const script = document.createElement('script');
          script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBCHOFkexiv1FAxJM0RalJEiqTXp-wqHuM&libraries=places&v=weekly';
          script.async = true;
          script.dataset.googleMaps = 'true';
          script.addEventListener('load', () => resolve());
          script.addEventListener('error', reject);
          document.head.append(script);
        });
      }

      #fetchPlace(placeId) {
        return new Promise((resolve, reject) => {
          const helper = document.createElement('div');
          const service = new window.google.maps.places.PlacesService(helper);
          service.getDetails(
            { placeId, fields: ['geometry', 'rating', 'user_ratings_total'] },
            (place, status) => {
              if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place?.geometry) {
                reject(new Error('place lookup failed'));
                return;
              }
              this.#renderMap(place.geometry.location.lat(), place.geometry.location.lng());
              this.#renderRating(place.rating, place.user_ratings_total);
              resolve();
            }
          );
        });
      }

      #renderRating(rating, total) {
        if (!rating) return;
        const wrap = this.closest('[data-section]')?.querySelector('[data-branch-rating]');
        const starsEl = wrap?.querySelector('[data-branch-rating-stars]');
        const countEl = wrap?.querySelector('[data-branch-rating-count]');
        if (!wrap || !starsEl || !countEl) return;

        starsEl.textContent = '★'.repeat(Math.round(rating));
        countEl.textContent = total ? `${rating} (${total})` : `${rating}`;
        wrap.hidden = false;
      }

      #renderMap(lat, lng) {
        this.#loadLeaflet()
          .then(() => {
            const map = window.L.map(this.#mapEl).setView([lat, lng], 16);
            window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; OpenStreetMap contributors',
            }).addTo(map);
            window.L.marker([lat, lng])
              .addTo(map)
              .bindPopup(`<strong>${this.dataset.title || ''}</strong>`)
              .openPopup();
          })
          .catch(() => this.#showFallback());
      }

      #loadLeaflet() {
        if (window.L) return Promise.resolve();

        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.append(css);

        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.addEventListener('load', () => resolve());
          script.addEventListener('error', reject);
          document.head.append(script);
        });
      }

      #showFallback() {
        if (this.#mapEl) this.#mapEl.hidden = true;
        if (this.#fallback) this.#fallback.hidden = false;
      }
    }

    customElements.define('branch-map', BranchMap);
  }

  } catch(e) { console.error(e); }
})();
})();
